import {useEffect, useState} from 'react'

/**
 * Keep value around and never clear it
 */
export const useCache = <Value>(value: Value): Value => {
  const [cached, setCache] = useState(value)

  useEffect(() => {
    if (value) setCache(value)
  }, [value])

  return cached
}
